import { setAvailableCredits } from 'Pods/ThreeDStudio/Store/actions/generation'
import {
  setMonthlyGenerationsAvailable,
  setMonthlyGenerationsUsed,
  setStudioAccessTier,
} from 'Pods/ThreeDStudio/Store/actions/subscription'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

// Applies a successful access-code response to the 3D Studio store. Passed to the shared
// AccessCodeForm as onApplied so the form itself stays store-agnostic and reusable on the
// (storeless) AI subscription landing page.
export default function applyAccessCodeResult(data = {}) {
  const tier = data.studioAccessTier || STUDIO_ACCESS_TIER.IN_FREE_BETA
  const monthlyAvailable = typeof data.monthlyGenerationsAvailable === 'number'
    ? data.monthlyGenerationsAvailable
    : 5
  const monthlyUsed = typeof data.monthlyGenerationsUsed === 'number'
    ? data.monthlyGenerationsUsed
    : 0

  setStudioAccessTier(tier)
  setMonthlyGenerationsAvailable(monthlyAvailable)
  setMonthlyGenerationsUsed(monthlyUsed)
  if (typeof data.availableCredits === 'number') {
    setAvailableCredits(data.availableCredits)
  }
}
